const lastWritten = new Map<string, unknown>()

/** Runs `write` unless `payload` is the same reference last written for `key`. */
export function mirrorOnce(key: string, payload: unknown, write: () => void): void {
  if (lastWritten.get(key) === payload) return
  lastWritten.set(key, payload)
  write()
}

/** Records a write made outside mirrorOnce so the next mirror of a different payload isn't skipped. */
export function noteMirrored(key: string, payload: unknown): void {
  lastWritten.set(key, payload)
}

export function __resetMirrorOnceForTest(): void {
  lastWritten.clear()
}
